<app-title-section ></app-title-section>

<div *ngIf="showEmptyStockAlert" class="alert alert-warning d-flex align-items-center mx-3 mt-2 mb-0" role="alert" style="border-radius: 8px;">
    <i class="bi bi-exclamation-triangle-fill me-2 flex-shrink-0"></i>
    <span>Alerte stock : la quantité totale est nulle alors qu’une alerte sur stock vide est activée pour ce produit.</span>
</div>

<div class="global-header d-flex flex-column flex-sm-row align-items-start w-100 flex-wrap" style="height: 160px; margin-bottom: 15px">

    <div class="flex-grow-1" style="margin-left: 15px">
        <div class="global-header d-flex flex-column flex-sm-row p-1 bg-white border-bottom rounded" style="height: 160px;">

            <div class="d-flex flex-column flex-sm-row w-100">
                <!-- Colonne gauche -->
                <div class="left-column d-flex flex-column  justify-content-start  flex-grow-1 gap-3" style="">

                    <h2 class="me-2 mb-0 size18">{{ productData.nom }}</h2>

                    <div class="d-flex align-items-center" style="margin-top: 12px;">
                        <img *ngIf="productData?.image && Object.keys(productData).length > 0"
                             src="{{ productData.image }}"
                             class="logo-img me-2"
                             alt=""/>
                        <i *ngIf="!productData?.image && Object.keys(productData).length > 0"
                           [size]="32"
                           data-feather="package"></i>

                    </div>

                </div>

                <!-- Ligne verticale -->
                <div class="vertical-divider d-none d-sm-block"></div>

                <!-- Colonne droite -->
                <div class="right-column d-flex flex-column justify-content-center ps-4 gap-2" style="margin-left: 23px;margin-top: 15px; margin-right: 23px;">

                    <div class=" size12 mb-1"><span class="text-primary size13 mb-1">Marque</span> <br> {{ productData.marque?.libelle }}</div>
                    <div class=" size12 mb-1"><span class="text-primary size13 mb-2">Catégorie</span> <br> {{ productData.categorie?.libelle }}</div>
                </div>
            </div>


        </div>
    </div>


    <!-- Card 2 -->
    <div class="flex-grow-1">
        <div class="  global-header d-flex flex-column flex-column p-2 bg-white border-bottom rounded vertical-item " style="height: 160px; margin-bottom: 15px">
            <div class="text-lg titlecard">Détails</div>
            <div class="custom-input-container">
                <div class="col-lg-4  items-center custom-input-container flex-grow-1">
                    <div class="iconGrid ">
                        <i [size]="16" data-feather="grid"></i>
                    </div>
                    <div>
                        <div class=" font-medium size18">{{ getRefFabricantDisplay() }}</div>
                        <div class=" text-gray-500 size13">Référence</div>
                    </div>
                </div>

                <div class="col-lg-5  items-center custom-input-container flex-grow-1">
                    <div class="icondollar ">
                        <i [size]="16" data-feather="dollar-sign"  class="avatar-icon"></i>
                    </div>
                    <div>
                        <div class="text-sm font-medium size18">{{ productData.prix_unitaires }} TND</div>
                        <div class="text-xs text-gray-500 size13">Prix de vente</div>
                    </div>
                </div>

                <div class="col-lg-4 items-center  custom-input-container flex-grow-1">
                    <div class="percent bg-rose-100 ">
                        <i [size]="16" data-feather="percent"  class="avatar-icon"></i>
                    </div>
                    <div>
                        <div class="text-sm font-medium size18"> {{productData.tva?.valeur}} %</div>
                        <div class="text-xs text-gray-500 size13">TVA</div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- Card 3 -->
    <div class="flex-grow-1">
    <div class="global-header d-flex flex-column flex-sm-row p-1 bg-white border-bottom rounded custom-input-container" style="height: 160px;"  >
        <div class="text-lg titlecard">Stock</div>
        <div class="d-flex align-items-center flex-grow-1 justify-content-center mt-3" style="max-width: 200px;gap: 16px">

            <div class=" cube me-2">
                <i data-feather="package" [size]="16"  class="avatar-icon"></i>
            </div>
            <div class="d-flex flex-column">
                <span class="size18">{{ totalQuantity ?? '---' }}</span>
                <span class="size13">En stock</span>
            </div>
        </div>

    </div>
    </div>
</div>


<div class="card " style="margin-left: 15px; margin-right: 15px; margin-bottom: 15px">

    <ul class="pt-1 nav nav-tabs " style=" border-bottom: 1px solid #eee; margin-bottom: 24px">
        <li class="nav-item" >
            <a
                    class="nav-link"
                    [class.active]="activeTab === 'overview'"
                    routerLink="vue-ensemble"
                    routerLinkActive="active"
                    (click)="selectTab('overview')"
                    href="javascript:void(0)"
            >
                Vue D'ensemble
            </a>
        </li>
        <li class="nav-item" >
            <a
                    class="nav-link"
                    routerLink="mouvement-stock"
                    routerLinkActive="active"
                    [class.active]="activeTab === 'stockMovement'"
                    (click)="selectTab('stockMovement')"
                    href="javascript:void(0)"
            >
                Mouvement de stock
            </a>
        </li>
        <li class="nav-item">
            <a
                    class="nav-link"
                    routerLink="numero-serie"
                    routerLinkActive="active"
                    [class.active]="activeTab === 'serialNumbers'"
                    (click)="selectTab('serialNumbers')"
                    href="javascript:void(0)"
            >
                Numéros de série
            </a>
        </li>

    </ul>

    <div class="tab-content mb-3">

        <router-outlet></router-outlet>
    </div>

</div>


